module.exports = __webpack_public_path__ + "img/damage-marker.36ce4dcb.svg";